// roleperms

const getters = {
	getRolePerms(state) {
		return state.roleperms;
	},

};

export default getters;